module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_6.c6907fa0.jpg";